import { trackPreviewSearchClickEvent, trackPreviewSearchSuggestionClickEvent } from '@sitecore-search/data';
import { PreviewSearchActionTypes } from '@sitecore-search/widgets';
import useBaseWidget from '../../../hooks/useBaseWidget.js';
import useQuery from '../../../hooks/useQuery.js';
import useWidget from '../../../hooks/useWidget.js';
import useWidgetActionsHandler from '../../../hooks/useWidgetActionsHandler.js';
import useWidgetActionsReducer from '../../../hooks/useWidgetActionsReducer.js';
import useWidgetRef from '../../../hooks/useWidgetRef.js';
import useWidgetState from '../../../hooks/useWidgetState.js';
import { getSearchEventData } from '../../../utils/events.js';
const contextReducer = (state, action) => {
    switch (action.type) {
        case PreviewSearchActionTypes.KEYPHRASE_CHANGED: {
            const { keyphrase } = action.payload;
            return {
                ...state,
                keyphrase,
            };
        }
        case PreviewSearchActionTypes.SUGGESTION_ADDED: {
            const { suggestion, max = 3 } = action.payload;
            return {
                ...state,
                suggestionsList: [...(state.suggestionsList || []), { suggestion, max }],
            };
        }
        case PreviewSearchActionTypes.SUGGESTION_REMOVED: {
            const { suggestion } = action.payload;
            return {
                ...state,
                suggestionsList: (state.suggestionsList || []).filter(({ suggestion: name }) => name !== suggestion),
            };
        }
        default:
            return state;
    }
};
function usePreviewSearch(config) {
    const { rfkId, entity, dispatch } = useBaseWidget();
    const control = useWidget();
    if (!control.isInitialized()) {
        control.initialize(config || {});
    }
    const { query, options, actions } = control;
    const state = useWidgetState();
    const queryResult = useQuery(query);
    const widgetRef = useWidgetRef();
    useWidgetActionsReducer(contextReducer, []);
    useWidgetActionsHandler((action) => {
        switch (action.type) {
            case PreviewSearchActionTypes.ITEM_CLICKED: {
                const { id, index, entity, sourceId } = action.payload;
                trackPreviewSearchClickEvent(rfkId, entity, {
                    index,
                    items: [
                        {
                            id,
                            sourceId,
                        },
                    ],
                    ...getSearchEventData(query),
                });
                break;
            }
            case PreviewSearchActionTypes.KEYPHRASE_CHANGED: {
                const { keyphrase } = action.payload;
                const request = query.getRequest();
                if (keyphrase !== '') {
                    request.setSearchQueryKeyphrase(keyphrase);
                }
                else {
                    request.resetSearchQueryKeyphrase();
                }
                break;
            }
            case PreviewSearchActionTypes.SUGGESTION_CLICKED: {
                const { name, title, value, displayName, uri, modifiedKeyword } = action.payload;
                trackPreviewSearchSuggestionClickEvent(rfkId, entity, {
                    filters: [
                        {
                            name,
                            title,
                            value,
                            displayName,
                            uri,
                        },
                    ],
                    ...getSearchEventData(query),
                    modifiedKeyword,
                });
                break;
            }
            case PreviewSearchActionTypes.SUGGESTION_ADDED: {
                const { suggestion, max = 3 } = action.payload;
                query
                    .getRequest()
                    .resetSearchFilter()
                    .removeSearchSuggestion({
                    name: suggestion,
                }, ({ name }) => name === suggestion)
                    .addSearchSuggestion({
                    name: suggestion,
                    max,
                });
                break;
            }
            case PreviewSearchActionTypes.SUGGESTION_REMOVED: {
                const { suggestion } = action.payload;
                query
                    .getRequest()
                    .resetSearchFilter()
                    .removeSearchSuggestion({
                    name: suggestion,
                }, ({ name }) => name === suggestion);
                break;
            }
        }
    }, [rfkId, query]);
    return { widgetRef, rfkId, state, queryResult, actions, options, dispatch, query };
}
export default usePreviewSearch;
